module.exports = __webpack_public_path__ + "hops_carousel_small.png";